// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-chat-context {
  justify-content: start !important;
}

.image-chat {
  width: 100%;
  max-height: 350px;
  border-radius: 8px;
  background-color: white !important;
  object-fit: cover;
  cursor: pointer;
}

.image-bubble {
  padding-right: 5px !important;
  padding-left: 5px !important;
  padding-top: 5px !important;
}

.button-chat {
  justify-content: center;
  align-items: center;
  display: flex;
  color: white;
  background-color: #4461f2;
  height: 32px;
  border-radius: 8px;
}

.top-content {
  background-color: #78c36e;
  border-radius: 8px;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 8px;
  color: white;
}

.top-content-you {
  background-color: rgb(230, 230, 230);
  border-radius: 8px;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 8px;
  color: #343a40;
}

.top-content-you:hover {
  color: #343a40;
}

.top-content:hover {
  color: white;
}

.file-icon {
  font-size: 20pt;
}

.file-thumbnail {
  font-size: 160pt;
}

.file-name {
  font-size: 14pt;
  font-weight: bold;
}

.file-info {
  font-size: 12pt;
}

.send-image {
  background-color: white;
  height: 100%;
  position: absolute;
  z-index: 100;
}

.send-image-content {
  position: relative;
  height: 100%;
}

.send-image-close {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20pt;
}

.audio-icon {
  font-size: 20pt;
  cursor: pointer;
}

.audio-timeline {
  background-color: white;
  cursor: pointer;
  width: 100%;
  height: 5px;
  border-radius: 2px;
}

.audio-progress {
  background-color: aqua;
  height: 100%;
}

.audio-icon-you {
  color: #324cca;
  font-size: 20pt;
  cursor: pointer;
}

.audio-timeline-you {
  background-color: rgb(172, 172, 172);
  cursor: pointer;
  width: 100%;
  height: 5px;
  border-radius: 2px;
}

.audio-progress-you {
  border-radius: 2px;
  background-color: aqua;
  height: 100%;
}

.location-content {
  background-color: #324cca;
  border-radius: 8px;
  height: 100px;
}

.location-name {
  font-size: 12pt;
  color: white;
}

.location-name:hover {
  color: white;
}

.sidebar-image {
  width: 100%;
  max-height: 60px;
  object-fit: cover;
  cursor: pointer;
}

.sidebar-document {
  width: 100%;
  height: 60px;
  background-color: #324cca;
  color: white;
  border-radius: 4px;
}

.sidebar-document:hover {
  color: white;
}

.sidebar-document-title {
  font-weight: bold;
}

.sidebar-header {
  position: fixed;
  width: 325px;
  top: 0;
  right: 0;
  background-color: white;
}
.search-message-header {
  width: 325px;
  top: 0;
  right: 0;
  background-color: white;
}

.reply-section {
  background-color: #78c36e;
  border-radius: 8px;
  min-height: 40px;
  display: flex;
  align-items: center;
  color: black;
  cursor: pointer;
}

.reply-section-you {
  background-color: rgb(230, 230, 230);
  border-radius: 8px;
  min-height: 40px;
  display: flex;
  align-items: center;
  color: #343a40;
  cursor: pointer;
}

.overflow-y-auto {
  overflow-y: auto;
  max-height: 500px;
  overflow-x: hidden;
}

.crm-recheck {
  font-size: 15px;
  background-color: #dfdfdf;
  border-radius: 3px;
  padding: 6px;
}

.history-crm-button {
  text-align: center;
  cursor: pointer;
}

.history-crm-row {
  padding: 5px 0;
}

@keyframes highlight-is-you {
  from {
    background-color: #cfcfcf;
  }

  to {
    background-color: #fff;
  }
}

@keyframes highlight-is-me {
  from {
    background-color: #6bad62;
  }

  to {
    background-color: #86d97b;
  }
}

.highlight__animate.is-you .chat-content .chat-bubbles .chat-bubble .chat-msg {
  animation: highlight-is-you 2s linear 0.1s;
}

.highlight__animate.is-me .chat-content .chat-bubbles .chat-bubble .chat-msg {
  animation: highlight-is-me 2s linear 0.1s;
}

.more-icon {
  bottom: -30px;
  right: 0;
  border-radius: 100%;
  padding: 3px;
}

.more-icon:hover {
  scale: 1.5;
  color: #324cca;
}

.modal-tag-main {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
}

.modal-tag-overlay {
  width: 100%;
  height: 100%;
  background-color: #343a4075;
  position: absolute;
  z-index: 1;
}
.modal-tag-body {
  z-index: 2;
  width: 40%;
  height: min-content;
  max-width: 550px;
  margin: auto;
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
}

.unread-count {
  font-weight: bold;
  color: white;
  background-color: #4461f2;
  left: -25px;
  bottom: 0;
  width: 20px;
  height: 20px;
  /* padding: 4px 8px; */
  border-radius: 100%;
  justify-content: center;
}

.reply-section-you:hover {
  color: #343a40;
}

.top-content:hover {
  color: white;
}

.read-more {
  color: blue;
  cursor: pointer;
}

.emoji-picker {
  position: absolute;
  bottom: 120%;
  left: 40px;
}

.reply-section-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* start showing ellipsis when 3rd line is reached */
  white-space: pre-wrap; /* let the text wrap preserving spaces */
}

.reply-section-bubble {
  overflow: hidden;
  max-height: 85px;
  padding: 8px;
}

.reply-section-media {
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
}

.reply-section-image {
  width: 100px;
  max-height: 100%;
}

.reply-image {
  aspect-ratio: 1 / 1;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  display: block;
  object-fit: cover;
}

.input-reply {
  width: 100%;
  padding: 16px 20px;
  display: flex;
}

.input-reply-content {
  background-color: rgb(230, 230, 230);
  border-radius: 8px;
  flex-grow: 1;
  padding: 8px;
  border-left: 10px solid #324cca;
}

.input-reply-title {
  font-weight: bold;
}

.input-reply-close {
  display: flex;
  align-items: center;
  justify-content: center;
}

.quick-reply-content {
  padding: 16px 20px;
  max-height: 10rem;
  overflow-y: scroll;
}

.time-separator {
  margin: 10px auto;
  width: fit-content;
  padding: 5px 10px;
  background-color: hsla(0, 0%, 100%, 0.95);
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
}

.quick-reply-command {
  font-weight: bold;
}

.quick-reply-item {
  cursor: pointer;
}

.quick-reply-item:hover {
  background-color: rgb(239, 239, 239);
}

.quick-reply-item-active {
  background-color: rgb(239, 239, 239);
}

.contact-modal-name {
  font-weight: bold;
  font-size: 12pt;
}

.contact-item-title {
  font-weight: bold;
}

.chat-body-shrink {
  /* margin-right: 325px; */
  transition: 0.3s;
}

.search-message-header {
  height: 72px;
  padding: 20px;
}

.search-message-content {
  padding: 10px 20px;
  background-color: white;
}

.search-message-title {
  font-weight: bold;
  font-size: 12pt;
}

.search-message-body {
  background-color: #f1f3f6;
  height: 100%;
}

.search-message-input {
  padding: 10px 20px;
}

.badge-list::-webkit-scrollbar {
  /* display: none; */
}

.chat-head-button {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 1;
}

.info-chat-head {
  z-index: 2;
}

.search-bar {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(100%);
  width: 325px;
  height: 100%;
  max-height: 100%;
  transition: transform 0.3s ease-in-out;
  background: #fff;
  z-index: 100;
}

.search-bar.visible {
  transform: none;
}

/* Modal resolve */
.modal-resolve-title {
  font-weight: bold;
  font-size: 14pt;
  color: #4461f2;
}

.modal-resolve-title.color-RESOLVED {
  color: #0fa958;
}

.modal-resolve-icon.blue {
  color: #4461f2;
}

.modal-resolve-icon {
  font-size: 50pt;
  color: #0fa958;
  text-transform: capitalize;
}

.modal-resolve-icon.pending-status,  .modal-resolve-title.color-PENDING {
  color:#f4bd0e;
  text-transform: capitalize;
}

/* Modal Image */
.icon-image-download {
  font-size: 24pt;
  cursor: pointer;
  color: white;
}

.button-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.play-button {
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  font-size: 44pt;
  cursor: pointer;
  color: white;
}

.button-reply-container {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
}

.button-reply {
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  background-color: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
}
.button-reply:hover {
  background-color: #e6e6e6;
}

.list-menu-chat {
  color: #324cca;
  border-top: 1px solid #343a4075;
  margin-top: 5px;
  padding: 10px 0;
  text-align: center;
  font-weight: 700;
}

.list-chat {
  cursor: pointer;
  border-radius: 2px;
  padding: 5px 20px;
  background-color: #c2e6be;
  color: black;
  border-top: 1px double #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  margin: 0px 2px 0 2px;
}
.list-chat:hover {
  background-color: #e6e6e6;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/chat.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB,EAAE,oDAAoD;EAC3E,qBAAqB,EAAE,wCAAwC;AACjE;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,4CAA4C;EAC5C,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,+CAA+C;AACjD;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".custom-chat-context {\r\n  justify-content: start !important;\r\n}\r\n\r\n.image-chat {\r\n  width: 100%;\r\n  max-height: 350px;\r\n  border-radius: 8px;\r\n  background-color: white !important;\r\n  object-fit: cover;\r\n  cursor: pointer;\r\n}\r\n\r\n.image-bubble {\r\n  padding-right: 5px !important;\r\n  padding-left: 5px !important;\r\n  padding-top: 5px !important;\r\n}\r\n\r\n.button-chat {\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n  color: white;\r\n  background-color: #4461f2;\r\n  height: 32px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.top-content {\r\n  background-color: #78c36e;\r\n  border-radius: 8px;\r\n  min-height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 8px;\r\n  color: white;\r\n}\r\n\r\n.top-content-you {\r\n  background-color: rgb(230, 230, 230);\r\n  border-radius: 8px;\r\n  min-height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 8px;\r\n  color: #343a40;\r\n}\r\n\r\n.top-content-you:hover {\r\n  color: #343a40;\r\n}\r\n\r\n.top-content:hover {\r\n  color: white;\r\n}\r\n\r\n.file-icon {\r\n  font-size: 20pt;\r\n}\r\n\r\n.file-thumbnail {\r\n  font-size: 160pt;\r\n}\r\n\r\n.file-name {\r\n  font-size: 14pt;\r\n  font-weight: bold;\r\n}\r\n\r\n.file-info {\r\n  font-size: 12pt;\r\n}\r\n\r\n.send-image {\r\n  background-color: white;\r\n  height: 100%;\r\n  position: absolute;\r\n  z-index: 100;\r\n}\r\n\r\n.send-image-content {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n.send-image-close {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 10px;\r\n  font-size: 20pt;\r\n}\r\n\r\n.audio-icon {\r\n  font-size: 20pt;\r\n  cursor: pointer;\r\n}\r\n\r\n.audio-timeline {\r\n  background-color: white;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  height: 5px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.audio-progress {\r\n  background-color: aqua;\r\n  height: 100%;\r\n}\r\n\r\n.audio-icon-you {\r\n  color: #324cca;\r\n  font-size: 20pt;\r\n  cursor: pointer;\r\n}\r\n\r\n.audio-timeline-you {\r\n  background-color: rgb(172, 172, 172);\r\n  cursor: pointer;\r\n  width: 100%;\r\n  height: 5px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.audio-progress-you {\r\n  border-radius: 2px;\r\n  background-color: aqua;\r\n  height: 100%;\r\n}\r\n\r\n.location-content {\r\n  background-color: #324cca;\r\n  border-radius: 8px;\r\n  height: 100px;\r\n}\r\n\r\n.location-name {\r\n  font-size: 12pt;\r\n  color: white;\r\n}\r\n\r\n.location-name:hover {\r\n  color: white;\r\n}\r\n\r\n.sidebar-image {\r\n  width: 100%;\r\n  max-height: 60px;\r\n  object-fit: cover;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-document {\r\n  width: 100%;\r\n  height: 60px;\r\n  background-color: #324cca;\r\n  color: white;\r\n  border-radius: 4px;\r\n}\r\n\r\n.sidebar-document:hover {\r\n  color: white;\r\n}\r\n\r\n.sidebar-document-title {\r\n  font-weight: bold;\r\n}\r\n\r\n.sidebar-header {\r\n  position: fixed;\r\n  width: 325px;\r\n  top: 0;\r\n  right: 0;\r\n  background-color: white;\r\n}\r\n.search-message-header {\r\n  width: 325px;\r\n  top: 0;\r\n  right: 0;\r\n  background-color: white;\r\n}\r\n\r\n.reply-section {\r\n  background-color: #78c36e;\r\n  border-radius: 8px;\r\n  min-height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  color: black;\r\n  cursor: pointer;\r\n}\r\n\r\n.reply-section-you {\r\n  background-color: rgb(230, 230, 230);\r\n  border-radius: 8px;\r\n  min-height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  color: #343a40;\r\n  cursor: pointer;\r\n}\r\n\r\n.overflow-y-auto {\r\n  overflow-y: auto;\r\n  max-height: 500px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.crm-recheck {\r\n  font-size: 15px;\r\n  background-color: #dfdfdf;\r\n  border-radius: 3px;\r\n  padding: 6px;\r\n}\r\n\r\n.history-crm-button {\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.history-crm-row {\r\n  padding: 5px 0;\r\n}\r\n\r\n@keyframes highlight-is-you {\r\n  from {\r\n    background-color: #cfcfcf;\r\n  }\r\n\r\n  to {\r\n    background-color: #fff;\r\n  }\r\n}\r\n\r\n@keyframes highlight-is-me {\r\n  from {\r\n    background-color: #6bad62;\r\n  }\r\n\r\n  to {\r\n    background-color: #86d97b;\r\n  }\r\n}\r\n\r\n.highlight__animate.is-you .chat-content .chat-bubbles .chat-bubble .chat-msg {\r\n  animation: highlight-is-you 2s linear 0.1s;\r\n}\r\n\r\n.highlight__animate.is-me .chat-content .chat-bubbles .chat-bubble .chat-msg {\r\n  animation: highlight-is-me 2s linear 0.1s;\r\n}\r\n\r\n.more-icon {\r\n  bottom: -30px;\r\n  right: 0;\r\n  border-radius: 100%;\r\n  padding: 3px;\r\n}\r\n\r\n.more-icon:hover {\r\n  scale: 1.5;\r\n  color: #324cca;\r\n}\r\n\r\n.modal-tag-main {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n}\r\n\r\n.modal-tag-overlay {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #343a4075;\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n.modal-tag-body {\r\n  z-index: 2;\r\n  width: 40%;\r\n  height: min-content;\r\n  max-width: 550px;\r\n  margin: auto;\r\n  background-color: white;\r\n  border-radius: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.unread-count {\r\n  font-weight: bold;\r\n  color: white;\r\n  background-color: #4461f2;\r\n  left: -25px;\r\n  bottom: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  /* padding: 4px 8px; */\r\n  border-radius: 100%;\r\n  justify-content: center;\r\n}\r\n\r\n.reply-section-you:hover {\r\n  color: #343a40;\r\n}\r\n\r\n.top-content:hover {\r\n  color: white;\r\n}\r\n\r\n.read-more {\r\n  color: blue;\r\n  cursor: pointer;\r\n}\r\n\r\n.emoji-picker {\r\n  position: absolute;\r\n  bottom: 120%;\r\n  left: 40px;\r\n}\r\n\r\n.reply-section-text {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 3; /* start showing ellipsis when 3rd line is reached */\r\n  white-space: pre-wrap; /* let the text wrap preserving spaces */\r\n}\r\n\r\n.reply-section-bubble {\r\n  overflow: hidden;\r\n  max-height: 85px;\r\n  padding: 8px;\r\n}\r\n\r\n.reply-section-media {\r\n  width: 100%;\r\n  padding: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.reply-section-image {\r\n  width: 100px;\r\n  max-height: 100%;\r\n}\r\n\r\n.reply-image {\r\n  aspect-ratio: 1 / 1;\r\n  border-top-right-radius: 8px;\r\n  border-bottom-right-radius: 8px;\r\n  display: block;\r\n  object-fit: cover;\r\n}\r\n\r\n.input-reply {\r\n  width: 100%;\r\n  padding: 16px 20px;\r\n  display: flex;\r\n}\r\n\r\n.input-reply-content {\r\n  background-color: rgb(230, 230, 230);\r\n  border-radius: 8px;\r\n  flex-grow: 1;\r\n  padding: 8px;\r\n  border-left: 10px solid #324cca;\r\n}\r\n\r\n.input-reply-title {\r\n  font-weight: bold;\r\n}\r\n\r\n.input-reply-close {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.quick-reply-content {\r\n  padding: 16px 20px;\r\n  max-height: 10rem;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.time-separator {\r\n  margin: 10px auto;\r\n  width: fit-content;\r\n  padding: 5px 10px;\r\n  background-color: hsla(0, 0%, 100%, 0.95);\r\n  font-size: 14px;\r\n  text-transform: uppercase;\r\n  border-radius: 5px;\r\n}\r\n\r\n.quick-reply-command {\r\n  font-weight: bold;\r\n}\r\n\r\n.quick-reply-item {\r\n  cursor: pointer;\r\n}\r\n\r\n.quick-reply-item:hover {\r\n  background-color: rgb(239, 239, 239);\r\n}\r\n\r\n.quick-reply-item-active {\r\n  background-color: rgb(239, 239, 239);\r\n}\r\n\r\n.contact-modal-name {\r\n  font-weight: bold;\r\n  font-size: 12pt;\r\n}\r\n\r\n.contact-item-title {\r\n  font-weight: bold;\r\n}\r\n\r\n.chat-body-shrink {\r\n  /* margin-right: 325px; */\r\n  transition: 0.3s;\r\n}\r\n\r\n.search-message-header {\r\n  height: 72px;\r\n  padding: 20px;\r\n}\r\n\r\n.search-message-content {\r\n  padding: 10px 20px;\r\n  background-color: white;\r\n}\r\n\r\n.search-message-title {\r\n  font-weight: bold;\r\n  font-size: 12pt;\r\n}\r\n\r\n.search-message-body {\r\n  background-color: #f1f3f6;\r\n  height: 100%;\r\n}\r\n\r\n.search-message-input {\r\n  padding: 10px 20px;\r\n}\r\n\r\n.badge-list::-webkit-scrollbar {\r\n  /* display: none; */\r\n}\r\n\r\n.chat-head-button {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  left: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.info-chat-head {\r\n  z-index: 2;\r\n}\r\n\r\n.search-bar {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  transform: translateX(100%);\r\n  width: 325px;\r\n  height: 100%;\r\n  max-height: 100%;\r\n  transition: transform 0.3s ease-in-out;\r\n  background: #fff;\r\n  z-index: 100;\r\n}\r\n\r\n.search-bar.visible {\r\n  transform: none;\r\n}\r\n\r\n/* Modal resolve */\r\n.modal-resolve-title {\r\n  font-weight: bold;\r\n  font-size: 14pt;\r\n  color: #4461f2;\r\n}\r\n\r\n.modal-resolve-title.color-RESOLVED {\r\n  color: #0fa958;\r\n}\r\n\r\n.modal-resolve-icon.blue {\r\n  color: #4461f2;\r\n}\r\n\r\n.modal-resolve-icon {\r\n  font-size: 50pt;\r\n  color: #0fa958;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.modal-resolve-icon.pending-status,  .modal-resolve-title.color-PENDING {\r\n  color:#f4bd0e;\r\n  text-transform: capitalize;\r\n}\r\n\r\n/* Modal Image */\r\n.icon-image-download {\r\n  font-size: 24pt;\r\n  cursor: pointer;\r\n  color: white;\r\n}\r\n\r\n.button-bar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n.play-button {\r\n  position: absolute;\r\n  z-index: 10;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(-50%);\r\n  font-size: 44pt;\r\n  cursor: pointer;\r\n  color: white;\r\n}\r\n\r\n.button-reply-container {\r\n  margin-top: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.button-reply {\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  padding: 5px 10px;\r\n  background-color: #fff;\r\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);\r\n}\r\n.button-reply:hover {\r\n  background-color: #e6e6e6;\r\n}\r\n\r\n.list-menu-chat {\r\n  color: #324cca;\r\n  border-top: 1px solid #343a4075;\r\n  margin-top: 5px;\r\n  padding: 10px 0;\r\n  text-align: center;\r\n  font-weight: 700;\r\n}\r\n\r\n.list-chat {\r\n  cursor: pointer;\r\n  border-radius: 2px;\r\n  padding: 5px 20px;\r\n  background-color: #c2e6be;\r\n  color: black;\r\n  border-top: 1px double #ffffff;\r\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);\r\n  margin: 0px 2px 0 2px;\r\n}\r\n.list-chat:hover {\r\n  background-color: #e6e6e6;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
